import { render, staticRenderFns } from "./AttributeImageSelector.vue?vue&type=template&id=12ec653d"
import script from "./AttributeImageSelector.vue?vue&type=script&lang=js"
export * from "./AttributeImageSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports